import { render, staticRenderFns } from "./ModelShare.vue?vue&type=template&id=0aaacb01&scoped=true"
import script from "./ModelShare.vue?vue&type=script&lang=js"
export * from "./ModelShare.vue?vue&type=script&lang=js"
import style0 from "./ModelShare.vue?vue&type=style&index=0&id=0aaacb01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaacb01",
  null
  
)

export default component.exports